import React, { useState } from "react";
import { useForm } from "react-hook-form";

import { useParams } from "react-router";

import ModalHolder from "../../molecules/ModalHolder";
import { toastWarning } from "../../../shared/helpers";

import { ErrorMessage } from "@hookform/error-message";
import { P } from "../../atoms/Texts";
import { PrimaryButton } from "../../atoms/Buttons";
import { DarkFormField, DarkTextArea } from "../../atoms/Inputs";

const CreateCaseNoteModal = ({ closeModal }) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    validateCriteriaMode: "all",
  });

  const onCreateNote = (data) => {
    toastWarning("Cannot perform this action on Demo mode");
  };

  return (
    <ModalHolder width="60%" header="Add Note" closeModal={closeModal}>
      <form className="py-10" onSubmit={handleSubmit(onCreateNote)}>
        <div>
          <DarkFormField
            type="text"
            id="title"
            name="title"
            placeholder="Title of note..."
            label="Title"
            {...register("title", {
              required: "Title is required",
            })}
          />

          <ErrorMessage
            errors={errors}
            name="title"
            as={<P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm" />}
          >
            {({ messages }) =>
              messages &&
              Object.entries(messages).map(([type, message]) => (
                <P key={type}>{message}</P>
              ))
            }
          </ErrorMessage>
        </div>

        <div>
          <DarkTextArea
            id="body"
            name="body"
            placeholder="..."
            rows={4}
            label="Body"
            {...register("body", {
              required: "Body is required",
            })}
          />

          <ErrorMessage
            errors={errors}
            name="body"
            as={<P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm" />}
          >
            {({ messages }) =>
              messages &&
              Object.entries(messages).map(([type, message]) => (
                <P key={type}>{message}</P>
              ))
            }
          </ErrorMessage>
        </div>

        <PrimaryButton className="w-full mt-10">Add Note</PrimaryButton>
      </form>
    </ModalHolder>
  );
};

export default CreateCaseNoteModal;
